import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { hostelAPI } from '../../services/api';
import { getErrorMessage } from '../../utils/errorHandler';

export const fetchDormitories = createAsyncThunk('hostel/dormitories', async (params, { rejectWithValue }) => {
  try {
    const response = await hostelAPI.fetchDormitories(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch dormitories'));
  }
});

export const createDormitory = createAsyncThunk('hostel/createDormitory', async (data, { rejectWithValue }) => {
  try {
    const response = await hostelAPI.createDormitory(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create dormitory'));
  }
});

export const fetchRooms = createAsyncThunk('hostel/rooms', async (params, { rejectWithValue }) => {
  try {
    const response = await hostelAPI.fetchRooms(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch rooms'));
  }
});

export const createRoom = createAsyncThunk('hostel/createRoom', async (data, { rejectWithValue }) => {
  try {
    const response = await hostelAPI.createRoom(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create room'));
  }
});

export const allocateRoom = createAsyncThunk('hostel/allocate', async (data, { rejectWithValue }) => {
  try {
    const response = await hostelAPI.allocateRoom(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to allocate room'));
  }
});

export const deallocateRoom = createAsyncThunk('hostel/deallocate', async (id, { rejectWithValue }) => {
  try {
    await hostelAPI.deallocateRoom(id);
    return id;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to deallocate room'));
  }
});

const initialState = {
  dormitories: [],
  rooms: [],
  allocations: [],
  stats: null,
  loading: false,
  error: null,
};

const hostelSlice = createSlice({
  name: 'hostel',
  initialState,
  reducers: {
    clearHostelError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDormitories.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDormitories.fulfilled, (state, action) => { state.loading = false; state.dormitories = action.payload.data || action.payload; })
      .addCase(fetchDormitories.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createDormitory.fulfilled, (state, action) => { state.dormitories.unshift(action.payload); })
      .addCase(fetchRooms.fulfilled, (state, action) => { state.rooms = action.payload.data || action.payload; })
      .addCase(createRoom.fulfilled, (state, action) => { state.rooms.unshift(action.payload); })
      .addCase(allocateRoom.fulfilled, (state, action) => { state.allocations.unshift(action.payload); })
      .addCase(deallocateRoom.fulfilled, (state, action) => { state.allocations = state.allocations.filter((a) => a.id !== action.payload); });
  },
});

export const { clearHostelError } = hostelSlice.actions;
export default hostelSlice.reducer;
